import {ScheduleAppointmentJourneyResponse, TaskStepName} from "@/api/dto/care-journey";
import {FilterInvalidate} from "@common/FilterComponent";
import {StepLink, Title} from "@/components/pages/tasks/task_edit/progress/TaskEditDetails.styles";
import {
  appointmentTypes,
  TERMINAL_APPOINTMENT_STATUSES
} from "@/components/pages/tasks/task_edit/progress/bh_journey/ScheduleAppointmentsStep.constants";
import {StandardTypography} from "patient-ping-remedy/packages/typography";
import Banner, {BannerTypes} from "patient-ping-remedy/packages/banner";
import {css} from "@emotion/css";
import {sizes} from "patient-ping-remedy/packages/theme";
import {useTaskStepName} from "@/hooks/useTaskStepName";
import AiWorkingBanner from "@common/AiWorkingBanner";
import AppointmentAiAssignment
  from "@/components/pages/tasks/task_edit/progress/bh_journey/AppointmentAiAssignment";

type Props = {
    careJourneyDetails: ScheduleAppointmentJourneyResponse;
    changeStep?(step: number): void;
    disabled: boolean;
    invalidate: FilterInvalidate;
}

const AppointmentDetails = (props : Props) => {
  const { taskStepDisplayValues } = useTaskStepName();
  const appointmentType = appointmentTypes[props.careJourneyDetails.providerType]
    ?? props.careJourneyDetails.providerType;
  const orchestrationEngineDetails = props.careJourneyDetails.orchestrationEngineDetails;
  const currentStepIndex = props.careJourneyDetails.steps.findIndex((step) =>
    step.stepName === props.careJourneyDetails.currentStep);
  const isClosed = props.careJourneyDetails.status === 'closed';
  const isTerminal = TERMINAL_APPOINTMENT_STATUSES.has(
    props.careJourneyDetails.status?.toLowerCase());
  const assignedToAi = props.careJourneyDetails.userAssignment.assignedToAi;

  return <div>
    <Title>{appointmentType}</Title>
    <StandardTypography>
      Appointment management to streamline scheduling, SMS reminders, appointment attendance confirmations,
      and patient engagement before each session.
    </StandardTypography>
    {!isTerminal && assignedToAi && <AiWorkingBanner />}
    {!isTerminal && !assignedToAi && orchestrationEngineDetails?.unassignedByAi
          && orchestrationEngineDetails.reasonStep === props.careJourneyDetails.currentStep && (
      <Banner type={BannerTypes.WARNING} className={css({ marginTop: sizes.medium })}>
        AI agent couldn’t complete{' '}
        <StepLink onClick={() => props.changeStep?.(currentStepIndex)}>
          {taskStepDisplayValues[orchestrationEngineDetails.reasonStep as TaskStepName]
            ?? orchestrationEngineDetails.reasonStep}
        </StepLink>.
        {orchestrationEngineDetails.reason?.trim()
          && <> {orchestrationEngineDetails.reason}.</>}
      </Banner>
    )}
    {orchestrationEngineDetails?.closeReason && isClosed &&
      <Banner type={BannerTypes.INFORMATIONAL} className={css({ marginTop: sizes.medium })}>
        This appointment was closed because {orchestrationEngineDetails.closeReason}
      </Banner>
    }
    <AppointmentAiAssignment
      careJourneyDetails={props.careJourneyDetails}
      disabled={props.disabled}
      invalidate={props.invalidate}
    />
  </div>;
};

export default AppointmentDetails;
